module.exports = __webpack_public_path__ + "img/square.6c845347.svg";